import Serializer from 'umg-ember-backend/serializers/application';

export default class ArtistSerializer extends Serializer {
  attrs = {
    promotionImage: 'assetIdPromotion',
    ownedByChannel: 'ownedByChannelId',
  };
}
